import { Badge } from "@/components/ui/badge";
import { Home, Building2, ArrowLeftRight } from "lucide-react";
import { cn } from "@/lib/utils";

const WORK_MODEL_CONFIG: Record<string, {
  label: string;
  icon: typeof Home;
  className: string;
}> = {
  remoto: {
    label: "Remoto",
    icon: Home,
    className: "bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800",
  },
  hibrido: {
    label: "Híbrido",
    icon: ArrowLeftRight,
    className: "bg-violet-100 text-violet-800 border-violet-200 dark:bg-violet-900/30 dark:text-violet-300 dark:border-violet-800",
  },
  presencial: {
    label: "Presencial",
    icon: Building2,
    className: "bg-muted text-muted-foreground border-border",
  },
};

interface WorkModelBadgeProps {
  model: string | null | undefined;
  size?: "sm" | "md";
  className?: string;
}

export function WorkModelBadge({ model, size = "md", className }: WorkModelBadgeProps) {
  if (!model) return null;

  const config = WORK_MODEL_CONFIG[model];
  if (!config) return null;

  const Icon = config.icon;

  return (
    <Badge
      variant="outline"
      className={cn(
        "gap-1 font-medium border",
        config.className,
        size === "sm" && "text-[10px] px-1.5 py-0.5",
        size === "md" && "text-xs px-2 py-0.5",
        className,
      )}
    >
      <Icon className={cn(size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5")} />
      {config.label}
    </Badge>
  );
}

export { WORK_MODEL_CONFIG };
